(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7700],{

/***/ 89605:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/register",
      function () {
        return __webpack_require__(90147);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64201);



var SignUp = function(param) {
    var param = param !== null ? param : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {});
};
/* harmony default export */ __webpack_exports__["default"] = (SignUp);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(89605); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);